import React from "react";
import {
  TextField,
  Switch,
  FormControlLabel,
  Button,
  Box,
  Typography,
  Paper,
  Divider,
} from "@mui/material";
import SportsSoccerIcon from "@mui/icons-material/SportsSoccer";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import styles from "./style.module.css";
import { MenuItem, Select } from "@mui/material";

const AppVersionForm = ({ formik, loading }) => {
  return (
    <Box
      component="form"
      onSubmit={formik.handleSubmit}
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        maxWidth: 400,
        padding: "20px",
      }}
      className={styles.noAutofill}
    >
      {/* Android Version */}
      <Box>
        <Typography variant="body2" sx={{ mb: 0.5 }}>
          Android Version
        </Typography>
        <TextField
          id="outlined-basic"
          placeholder="Enter Android Version"
          name="android_version"
          value={formik.values.android_version}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          type="text"
          fullWidth
          size="small"
          error={
            formik.touched.android_version &&
            Boolean(formik.errors.android_version)
          }
          helperText={
            formik.touched.android_version && formik.errors.android_version
          }
        />
      </Box>

      {/* Force Update Android */}
      <FormControlLabel
        control={
          <Switch
            name="forcefully_update_android"
            checked={formik.values.forcefully_update_android}
            onChange={formik.handleChange}
            size="small"
            className={styles.redSwitch}
          />
        }
        label="Force Update Android"
      />

      {/* iOS Version */}
      <Box>
        <Typography variant="body2" sx={{ mb: 0.5 }}>
          iOS Version
        </Typography>
        <TextField
          id="outlined-basic"
          placeholder="Enter iOS Version"
          name="ios_version"
          value={formik.values.ios_version}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          type="text"
          fullWidth
          size="small"
          error={
            formik.touched.ios_version && Boolean(formik.errors.ios_version)
          }
          helperText={formik.touched.ios_version && formik.errors.ios_version}
        />
      </Box>

      {/* Force Update iOS */}
      <FormControlLabel
        control={
          <Switch
            name="forcefully_update_ios"
            checked={formik.values.forcefully_update_ios}
            onChange={formik.handleChange}
            size="small"
            className={styles.redSwitch}
          />
        }
        label="Force Update iOS"
      />
      {/* Default Leaderboard */}

      <Box>
        <Typography variant="body2" sx={{ mb: 0.5 }}>
          Default Leaderboard
        </Typography>

        <Select
          fullWidth
          size="small"
          name="default_leaderboard"
          value={formik.values.default_leaderboard}
          onChange={formik.handleChange}
        >
          <MenuItem value="monthly">Monthly Leaderboard</MenuItem>

          <MenuItem value="seasonal">Seasonal Leaderboard</MenuItem>
        </Select>
      </Box>

      <Divider sx={{ my: 1 }} />

      <Paper
        elevation={0}
        sx={{
          p: 2,
          borderRadius: 2,
          border: "1px solid #eceef3",
          bgcolor: "#fafbfc",
        }}
      >
        <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 0.5 }}>
          Guest voting
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Control whether guest users (app and web) can cast trial votes in
          football and pageant sections. When disabled, guests see a message
          asking them to register or log in.
        </Typography>

        <FormControlLabel
          control={
            <Switch
              name="guest_football_votes_enabled"
              checked={Boolean(formik.values.guest_football_votes_enabled)}
              onChange={formik.handleChange}
              size="small"
              className={styles.redSwitch}
            />
          }
          label={
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <SportsSoccerIcon fontSize="small" />
              Football guest votes {formik.values.guest_football_votes_enabled ? "enabled" : "disabled"}
            </Box>
          }
          sx={{ display: "flex", mb: 1 }}
        />

        <FormControlLabel
          control={
            <Switch
              name="guest_pageant_votes_enabled"
              checked={Boolean(formik.values.guest_pageant_votes_enabled)}
              onChange={formik.handleChange}
              size="small"
              className={styles.redSwitch}
            />
          }
          label={
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <EmojiEventsIcon fontSize="small" />
              Pageant guest votes {formik.values.guest_pageant_votes_enabled ? "enabled" : "disabled"}
            </Box>
          }
          sx={{ display: "flex" }}
        />
      </Paper>

      {/* Buttons */}
      <Box sx={{ display: "flex", gap: 2 }}>
        <Button
          type="submit"
          variant="contained"
          size="small"
          className={formik.dirty ? styles.dirtyButton : styles.primaryButton}
          disabled={loading}
          // sx={{
          //   backgroundColor: formik.dirty ? "#ff9800" : "#1976d2", // orange when changed
          // }}
        >
          {loading ? "Saving..." : formik.dirty ? "Save Changes" : "Saved"}
        </Button>
      </Box>
    </Box>
  );
};

export default AppVersionForm;
